var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 18.6109C43.2178 15.8675 42.6309 13.1446 41.4188 10.6951C40.5964 9.68999 39.4551 9.0117 38.1938 8.77842C32.9767 8.29451 27.7379 8.09618 22.5 8.18426C17.2813 8.09218 12.0614 8.28412 6.86255 8.75926C5.83471 8.95038 4.88352 9.44321 4.12505 10.1776C2.43755 11.7684 2.25005 14.4901 2.06255 16.7901C1.79051 20.9254 1.79051 25.0748 2.06255 29.2101C2.11679 30.5046 2.30535 31.7896 2.62505 33.0434C2.85113 34.0115 3.30853 34.9071 3.9563 35.6501C4.71993 36.4234 5.69327 36.9442 6.75005 37.1451C10.7924 37.6552 14.8655 37.8665 18.9376 37.7776C25.5001 37.8734 31.2563 37.7776 38.0625 37.2409C39.1453 37.0524 40.146 36.5309 40.9313 35.7459C41.4562 35.2091 41.8483 34.552 42.0751 33.8293C42.7456 31.7259 43.075 29.5246 43.05 27.3126C43.125 26.2393 43.125 19.7609 43.125 18.6109ZM18.2626 28.4626V16.5984L29.3625 22.5593C26.25 24.3226 22.1438 26.3159 18.2626 28.4626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d8ba08de832faec0d85074dd70954bf2.svg";
export { ForwardRef as ReactComponent };